import { forwardRef, type InputHTMLAttributes, type ClipboardEvent, type ChangeEvent } from 'react';
import { maskMoneyInput } from '@caixa/lib/moneyMask';

export type MoneyInputProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'type' | 'inputMode' | 'onChange' | 'value'
> & {
  value: string;
  onChange: (value: string) => void;
  currencyPrefix?: boolean;
  inputClassName?: string;
};

export const MoneyInput = forwardRef<HTMLInputElement, MoneyInputProps>(
  (
    {
      value,
      onChange,
      onPaste,
      placeholder = '0,00',
      className,
      currencyPrefix = false,
      inputClassName,
      ...props
    },
    ref,
  ) => {
    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      onChange(maskMoneyInput(e.target.value));
    };

    const handlePaste = (e: ClipboardEvent<HTMLInputElement>) => {
      e.preventDefault();
      onChange(maskMoneyInput(e.clipboardData.getData('text')));
      onPaste?.(e);
    };

    if (currencyPrefix) {
      return (
        <div className={`caixa-money-input ${className ?? ''}`}>
          <span className="caixa-money-input__prefix">R$</span>
          <input
            ref={ref}
            type="text"
            inputMode="numeric"
            autoComplete="off"
            value={value}
            onChange={handleChange}
            onPaste={handlePaste}
            placeholder={placeholder}
            className={`caixa-money-input__field ${inputClassName ?? ''}`}
            {...props}
          />
        </div>
      );
    }

    return (
      <input
        ref={ref}
        type="text"
        inputMode="numeric"
        autoComplete="off"
        value={value}
        onChange={handleChange}
        onPaste={handlePaste}
        placeholder={placeholder}
        className={className}
        {...props}
      />
    );
  },
);

MoneyInput.displayName = 'MoneyInput';
